import React from "react";
import CallToAction from "../partials/cta";
import CustomStepper from "./stepper";
import SectionTitle from "../../../components/sectionTitle";
import { withStyles } from "@mui/styles";
import { Box, Typography } from "@mui/material";
import { useStyles } from "../indexFormStyles";
import { BUTTON_PROCEED } from "../../../constants";

function BuyflowOverviewForm({
  classes: { containerButton, formGroup, main },
  activeStep = 1,
  errorMessage = {},
  modal,
  handleBack,
  isFormSubmitted,
  form,
  onSubmit,
  toggleModal,
  totalStep = 6,
}) {
  return (
    <Box className={main} mt={2}>
      <form noValidate autoComplete="off" onSubmit={onSubmit}>
        <Box display="flex" justifyContent="center" mt={2}>
          <SectionTitle
            title={"Journey Overview"}
            onClickHandler={handleBack}
          />
        </Box>

        <Box justifyContent="center" textAlign={"center"} mt={2}>
          <Box className={formGroup} pt={2}>
            <Typography variant="caption" fontWeight={450}>
              You are just <b>{totalStep - activeStep} steps away</b> from insta
              policy confirmation.
            </Typography>
          </Box>

          <Box m={2}>
            <CustomStepper
              activeStep={activeStep}
              errorMessage={errorMessage}
              modal={modal}
              isFormSubmitted={isFormSubmitted}
              form={form}
              onSubmit={onSubmit}
              toggleModal={toggleModal}
            />
          </Box>
        </Box>

        <Box
          className={containerButton}
          justifyContent="center"
          alignContent="center"
        >
          <CallToAction
            buttonType={"submit"}
            errorMessage={errorMessage}
            form={form}
            isFormSubmitted={isFormSubmitted}
            text={BUTTON_PROCEED}
            handleClick={() => {}}
            marginTopClass={"marginTop10"}
          />
        </Box>
      </form>
    </Box>
  );
}

export default withStyles(useStyles, { withTheme: true })(BuyflowOverviewForm);
